export function toggle() {

	const toggleNodes = document.querySelectorAll('.toggle');
	let toggles; 

	if (!toggleNodes) {
		return
	}

	toggles = Array.from(toggleNodes);

	toggles.forEach(toggle => {
		let parent = toggle.parentElement;
		let content = parent.nextElementSibling;

		toggle.setAttribute('aria-expanded', 'false');
		content.classList.add('hidden');

		toggle.addEventListener('click', (e) => {
			let expanded = toggle.getAttribute('aria-expanded') === 'true' || false;
			toggle.setAttribute('aria-expanded', !expanded);
			content.classList.toggle('hidden');
		});
	})

}